import { mount } from 'enzyme';
import * as React from 'react';
import EllipsisText from './ellipsisText';

describe('Ellipsis Text', () => {
  test('should match snapshot with label', () => {
    expect(
      mount(<EllipsisText text={'Click'} length={10} />),
    ).toMatchSnapshot();
  });

  test('should match snapshot for ellipsis truncating text', () => {
    expect(mount(<EllipsisText text={'Click'} length={3} />)).toMatchSnapshot();
  });

  test('should match snapshot for ellipsis truncating text with tail', () => {
    expect(
      mount(
        <EllipsisText
          text={'Click'}
          length={3}
          tail={'###'}
          tailclassname={'dummy'}
        />,
      ),
    ).toMatchSnapshot();
  });
});
